export default {
  name: 'marking--queryRequest',
  apiService: 'shoes',
  apiPath: '/admin/query_requests',
};